import { MANUAL_CHECK_CONFIG } from '../constants/manualCheck';

export const shouldDoManualCheck = (marketName) => {
	return marketName in MANUAL_CHECK_CONFIG;
};
